import React, { useState, useEffect } from "react"
import { fetchUserStats } from "@services/getUserStats"

const Header = () => {
  const [userStats, setUserStats] = useState(null)
  const userId = localStorage.getItem("userId")

  useEffect(() => {
    if (!userId) return

    const fetchUserStatsData = async () => {
      const response = await fetchUserStats(userId)
      setUserStats(response?.data?.data)
    }
    fetchUserStatsData()
  }, [userId])

  return (
    <header className="fixed flex items-center justify-between top-0 left-0 w-full z-[100] bg-white shadow-sm px-6 py-4 pl-[40px] h-[68px] border-b border-gray-200">
      <span
        className="text-[#6D65ED] font-extrabold text-[24px] leading-[130%] tracking-[-0.03em] text-xl"
        style={{ fontFamily: "Plus Jakarta Sans, sans-serif" }}
      >
        soma
      </span>
      {userStats?.total_ads_launched ? (
        <div className="rounded-xl bg-[#f7f7f7] px-3 py-1.5 text-xs font-medium text-black border border-gray-200">
          Ads Launched: {userStats?.total_ads_launched}
        </div>
      ) : null}
    </header>
  )
}

export default Header
